import { render, staticRenderFns } from "./IndividualH.vue?vue&type=template&id=5825ad4a&scoped=true"
import script from "./IndividualH.vue?vue&type=script&lang=js"
export * from "./IndividualH.vue?vue&type=script&lang=js"
import style0 from "./IndividualH.vue?vue&type=style&index=0&id=5825ad4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825ad4a",
  null
  
)

export default component.exports